import { createContext, useContext, useEffect } from 'react';

// Always dark/night mode — light mode removed
const ThemeCtx = createContext({ dark: true, toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.remove('light');
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <ThemeCtx.Provider value={{ dark: true, toggle: () => {} }}>
      {children}
    </ThemeCtx.Provider>
  );
};

export const useTheme = () => useContext(ThemeCtx);
